import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'moxi-search-field',
  imports: [
    TranslatePipe,

    // Ant Design
    NzButtonModule,
    NzInputModule,
    NzIconModule
  ],
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFieldComponent {
  term = input<string | null>();

  searchUpdate = output<string | null>();

  searchTerm = computed(() => this.term() ?? '');
}
